module.exports = require("@swissquote/crafty/packages/is-negated-glob.js");